import { FoodImageChoice } from 'earn-ts';
import { useState } from 'react';
import { useAppSelector } from 'src/app/store';
import { imgService } from 'src/utils';
import { LazyLoadImage } from 'react-lazy-load-image-component';

type IProps = {
  food: FoodImageChoice;
  alt?: string;
  className?: string;
  defaultUri?: string;
};

/** Handles default image as well as finding the correct url*/
export default function FoodImage({
  food,
  className,
  alt,
  defaultUri,
}: IProps) {
  const { shopId } = useAppSelector(state => state.order);
  const uri = imgService(shopId).getImgUri(food);
  const [url, setUrl] = useState(uri);
  const [error, setError] = useState(false);

  return !error ? (
    <div id="img_wrap" className={className + ' relative'}>
      <LazyLoadImage
        loading="lazy"
        src={url}
        placeholderSrc={defaultUri ?? '/defaultImage.jpeg'}
        className="top-0 left-0 absolute w-full h-full indent-[-10000]"
        alt={url}
        onError={() => (defaultUri ? setUrl(defaultUri) : setError(true))}
      />
    </div>
  ) : null;
}
